<template>
  <div class="oldmanmap">
    <div id="container" ref="amap" class="map"></div>
  </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import myIconImg from "@/assets/map/location.png"; // 定位图标
import watchgps_icon from "@/assets/map/watchgps_icon.png";
export default {
  data() {
    return {
      iconLocation: { url: myIconImg, size: { width: 48, height: 48 } },
      myIconImg: myIconImg,
      iconWatch: { url: watchgps_icon, size: { width: 48, height: 48 } },
      markers: [], //marker点集合
      center: { lng: 0, lat: 0 }, //中心点
      map:null,
      zoom: 19, //缩放比例
      mapType: "", //地图类型，不填就是默认样式
      //设置自定义主题
      mapStyle: {
        styleJson: [
        ]
      }
    };
  },
  methods: {
    initAMap() {
      const _this = this
      AMapLoader.load({
        key: 'bb369d6617c417b4826cee55ac7ad116',
        version: '2.0',
        plugins: []
      })
        .then((AMap) => {
          // _this.map = new AMap.Map("container", {
          //   zoom: 12, //初始化地图级别
          //   zooms: [5, 30], // 地图缩放范围
          //   center: [114.311584, 30.598467], //初始化地图中心点位置
          // });
          _this.getOldmanGeoPoint(AMap);
        })
        .catch((e) => {
          console.log(e)
        })
    },
    //获取老人的地理位置信息
    getOldmanGeoPoint(AMap) {
      const _this = this;
      this.$postJson("omc/Oldman/queryOldmanAddress")
        .then(res => {
          // console.log(res)
          if (res.result != null) {

            if (res.result != null && res.result.length > 0) {
              let lng = '114.311584';
              let lat = '30.598467';
              if(res.result[0].oldAddressBdGps!=null && res.result[0].oldAddressBdGps.split(",").length>1){
                lng = res.result[0].oldAddressBdGps.split(",")[0]; //老人家庭住址百度经度
                lat = res.result[0].oldAddressBdGps.split(",")[1]; //老人家庭住址百度纬度
              }
              const map = new AMap.Map('container', {
                zoom: 12, // 初始化地图级别
                zooms: [5, 30], // 地图缩放范围
                // 可以设置初始化当前位置
                center: [lng, lat]
              })
              this.map = map;
              res.result.forEach((item, index) => {
                console.log(item, index);
                //声明一个对象来存放老人地图定位的信息(title,经纬度，姓名，年龄，信息提示框的状态)
                let obj = {};
                if (item.oldAddressBdGps != null && item.oldAddressBdGps.length > 5) {
                  obj.lng = item.oldAddressBdGps.split(",")[0]; //老人家庭住址百度经度
                  obj.lat = item.oldAddressBdGps.split(",")[1]; //老人家庭住址百度纬度
                  obj.name = item.oldName; //title为老人姓名
                  obj.oldName = item.oldName; //老人姓名
                  obj.oldAddress = item.oldAddress; //l老人家庭住址
                  obj.oldAge = item.oldAge; //老人年龄
                  obj.infoWindowShoeFlag = false; //提示框显示的状态
                  item.sex == 0 ? (obj.sex = "男") : (obj.sex = "女"); //性别
                  const markerContent = `<div class="amap-maker-icon">
                    <div class="title">${item.oldName},${obj.sex},${obj.oldAge}岁
                      <br>
                      <span class="small">${item.oldAddress}</span>
                    </div>
                  </div>`;
                  var marker = new AMap.Marker({
                    position: [Number(obj.lng), Number(obj.lat)],
                    content: markerContent,
                  });
                  this.map.add(marker)
                }
              });
            }
          }
        })
    },
    foundMarker(map, markerData) {
      console.log(markerData, "markermarker");
      // 创建自定义图标
      var myIcon = new BMapGL.Icon(this.myIconImg, new BMapGL.Size(48, 48));
      // 创建点标记
      var point = new BMapGL.Point(markerData.lng, markerData.lat);
      map.centerAndZoom(point, 15);
      // var marker = new BMapGL.Marker(point,{icon: myIcon});// 自定义标点图标
      var marker = new BMapGL.Marker(point);
      map.addOverlay(marker);
      // 创建信息窗口
      var opts = {
        width: 200,
        height: 100,
        title: "老人信息"
      };
      var infoWindow = new BMapGL.InfoWindow(
        `<p>老人姓名:${markerData.oldName}</p>
            <p>老人性别:${markerData.sex}</p>
            <p>老人年龄:${markerData.oldAge}</p>
            <p>地理位置:${markerData.oldAddress}</p>`,
        opts
      );
      // 点标记添加点击事件
      marker.addEventListener("click", function (data) {
        map.openInfoWindow(infoWindow, point); // 开启信息窗口
      });
    }
  },
  created() {
    this.initAMap();
  },
  mounted() { }
};
</script>
<style lang="scss" scoped>
.oldmanmap {
  margin: 5px;
  border: 1px solid rgb(228, 222, 222);

  .map {
    width: 100%;
    height: 86vh;
  }
}


::v-deep #container {
  height: 800px;
  width: 100%;

  .amap-maker-icon {
    position: relative;
    height: 10px;
    width: 10px;
    border-radius: 10px;

    &:hover {
      .title {
        display: block;
      }
    }

    .title {
      // display: none;
      position: absolute;
      top: -20px;
      left: -70px;
      width: 150px;
      text-align: center;
      color: #333;
      font-size: 14px;
      border-radius: 5px;
      background: rgba(256, 256, 256)
    }
    .small{
      font-size: 10px;
    }
  }
}
//地图插件·
::v-deep .BMap_stdMpCtrl {
  top: 50px !important;
}

::v-deep .citylist_popup_main {
  margin-left: 45px;
}</style>
